module.exports = __webpack_public_path__ + "img/hermes-carbg-2.e21a0f9a.jpeg";